import React from "react";
import MaterialTable from "material-table";
import PropTypes from "prop-types";

const TableClients = ({ column, data, onRowClick, selectedRow }) => {
  return (
    <MaterialTable
      title="Lista de clientes"
      columns={column}
      data={data}
      onRowClick={onRowClick}
      options={{
        rowStyle: row =>
          row?.ID_CLIENTE === selectedRow?.ID_CLIENTE
            ? { background: "#e7e7e7" }
            : {}
      }}
    />
  );
};

TableClients.propTypes = {
  column: PropTypes.array,
  data: PropTypes.array,
  onRowClick: PropTypes.func,
  selectedRow: PropTypes.object
};
export default TableClients;
